import { render, staticRenderFns } from "./PurchaseData.vue?vue&type=template&id=c21c2ecc&scoped=true&"
import script from "./PurchaseData.vue?vue&type=script&lang=js&"
export * from "./PurchaseData.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseData.vue?vue&type=style&index=0&id=c21c2ecc&prod&lang=css&"
import style1 from "./PurchaseData.vue?vue&type=style&index=1&id=c21c2ecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21c2ecc",
  null
  
)

export default component.exports